import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Curious } from '@curi/react';

import './Contact.css';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
import PageHeader from '../../components/global/PageHeader';

class ContactUs extends React.PureComponent {
    componentDidMount() {
        gtmPageviewEvent({
            pageName: 'codespark.com: Contact',
            componentProps: this.props,
        });
    }

    render() {
        return (
            <div className="about-page page">
                <Helmet>
                    <title>Contact us | codeSpark</title>
                    <meta name="description" content="codeSpark’s mission is to make computer science education accessible to kids everywhere." />
                    <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
                    <meta property="og:title" content="Coding Game for Kids - Try it Free!" />
                    <meta property="og:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
                    <meta name="twitter:card" content="app" />
                    <meta name="twitter:site" content="@codesparkapp" />
                    <meta name="twitter:description" content="Try the #1 learn-to-code app for kids 4+. Used by over 20 Million kids, codeSpark teaches coding basics through creative play and game creation. Coding improves STEM, reading, and math skills." />
                    <meta name="twitter:app:country" content="US" />
                    <meta name="twitter:app:id:iphone" content="923441570" />
                    <meta name="twitter:app:id:ipad" content="923441570" />
                    <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
                </Helmet>
                <PageHeader text="Contact Us" />
                <div className="contactus-parent">
                    <div className="contactus-child">
                        <h2>If you are experiencing any trouble with the app or subscription,</h2>
                        <h2>email us at <a href="mailto:support@codespark.com"> support@codespark.com</a>.</h2>
                        <h2>We'll be happy to help!</h2>
                    </div>
                    <div className="contactus-child"><img src="https://d2bqrn11jthp5j.cloudfront.net/flagship/about/DogFoo_Support.png" alt="" /></div>
                </div>
            </div>
        );
    }
}

ContactUs.contextTypes = {
    mixpanel: PropTypes.object
};

export default props => (
    <Curious>
        {({ router, response, navigation }) => {
            return <ContactUs router={ router } response={ response } { ...props } />;
        }}
    </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/Contact/index.js